import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { SelectSearchModule } from 'src/components/select-search/select-search.module'
import { ValidationWarningComponent } from 'src/components/validation-warning/validation-warning.component'
import { DocsCountryConfirmationDialogComponent } from './docs-country-confirmation-dialog.component'
import { DocsCountryConfirmationDialogService } from './docs-country-confirmation-dialog.service'

@NgModule({
  declarations: [
    DocsCountryConfirmationDialogComponent,
  ],
  providers: [DocsCountryConfirmationDialogService],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    SelectSearchModule,
    ValidationWarningComponent,
  ],
})
export class DocsCountryConfirmationDialogModule { }
